import React, { useState, useEffect } from 'react';
import apiClient from '../services/api';

const Reports = ({ lang = 'lo', theme = 'dark' }) => {
  const [reportType, setReportType] = useState('transaction');
  const [dateFrom, setDateFrom] = useState(() => {
    const d = new Date();
    d.setDate(d.getDate() - 30);
    return d.toISOString().split('T')[0];
  });
  const [dateTo, setDateTo] = useState(() => new Date().toISOString().split('T')[0]);
  const [selectedModule, setSelectedModule] = useState('all');
  const [selectedStation, setSelectedStation] = useState('all');
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Station data by module
  const stationsByModule = {
    toll: [
      { id: 'TL-VTE-01', code: 'BOK-GATE-02', name: { lo: 'ດ່ານ KM 3 ວຽງຈັນ', th: 'ด่าน KM 3 เวียงจันทน์', en: 'KM 3 Vientiane' } },
      { id: 'TL-VTE-02', code: 'TL-VTE-02', name: { lo: 'ດ່ານ ທ່ານາແລງ', th: 'ด่านท่านาแหลน', en: 'Tha Nalaeng' } },
      { id: 'TL-CPS-01', code: 'TL-CPS-01', name: { lo: 'ດ່ານ ປາກເຊ', th: 'ด่านปากเซ', en: 'Pakxe Gate' } },
      { id: 'TL-SVK-01', code: 'TL-SVK-01', name: { lo: 'ດ່ານ ສະຫວັນ 1', th: 'ด่านสะหวัน 1', en: 'Savannakhet 1' } },
      { id: 'TL-SVK-02', code: 'TL-SVK-02', name: { lo: 'ດ່ານ ສະຫວັນ 2', th: 'ด่านสะหวัน 2', en: 'Savannakhet 2' } },
    ],
    bridge: [
      { id: 'BR-VTE-01', code: 'BR-VTE-01', name: { lo: 'ສະພານ ມິດຕະພາບ 1', th: 'สะพานมิตรภาพ 1', en: 'Friendship Bridge 1' } },
      { id: 'BR-SVK-01', code: 'BR-SVK-01', name: { lo: 'ສະພານ ມິດຕະພາບ 2', th: 'สะพานมิตรภาพ 2', en: 'Friendship Bridge 2' } },
      { id: 'BR-KHM-01', code: 'BR-KHM-01', name: { lo: 'ສະພານ ມິດຕະພາບ 3', th: 'สะพานมิตรภาพ 3', en: 'Friendship Bridge 3' } },
      { id: 'BR-BOK-01', code: 'BR-BOK-01', name: { lo: 'ສະພານ ມິດຕະພາບ 4', th: 'สะพานมิตรภาพ 4', en: 'Friendship Bridge 4' } },
    ],
    wim: [
      { id: 'WM-VTE-01', code: 'WM-VTE-01', name: { lo: 'ຈຸດ WIM KM4 ວຽງຈັນ', th: 'จุด WIM KM4 เวียงจันทน์', en: 'WIM KM4 Vientiane' } },
      { id: 'WM-SLV-01', code: 'WM-SLV-01', name: { lo: 'ຈຸດ WIM ດ່ານ ສາລະວັນ', th: 'จุด WIM ด่านสาละวัน', en: 'WIM Salavan' } },
      { id: 'WM-CPS-01', code: 'WM-CPS-01', name: { lo: 'ຈຸດ WIM ປາກເຊ', th: 'จุด WIM ปากเซ', en: 'WIM Pakxe' } },
    ],
    auction: [
      { id: 'AU-VTE-01', code: 'AU-VTE-01', name: { lo: 'ສູນປະມູນ ວຽງຈັນ', th: 'ศูนย์ประมูล เวียงจันทน์', en: 'Auction Center Vientiane' } },
      { id: 'AU-CPS-01', code: 'AU-CPS-01', name: { lo: 'ສູນປະມູນ ປາກເຊ', th: 'ศูนย์ประมูล ปากเซ', en: 'Auction Center Pakxe' } },
      { id: 'AU-SVK-01', code: 'AU-SVK-01', name: { lo: 'ສູນປະມູນ ສະຫວັນ', th: 'ศูนย์ประมูล สะหวัน', en: 'Auction Center Savannakhet' } },
    ],
  };

  const i18n = {
    lo: {
      title: 'ລາຍງານ',
      subtitle: 'ສ້າງ ແລະ ສົ່ງອອກລາຍງານຕ່າງໆຈາກລະບົບເກັບຄ່າທາງອັດຕະໂນມັດ',
      reportType: 'ປະເພດລາຍງານ',
      startDate: 'ວັນທີເລີ່ມຕົ້ນ',
      endDate: 'ວັນທີສິ້ນສຸດ',
      generateReport: 'ສ້າງລາຍງານ',
      exportExcel: 'ສົ່ງອອກ Excel',
      exportPdf: 'ສົ່ງອອກ PDF',
      daily: 'ລາຍງານປະຈຳວັນ',
      monthly: 'ລາຍງານປະຈຳເດືອນ',
      transaction: 'ລາຍງານທຸລະກຳ',
      revenue: 'ລາຍງານລາຍຮັບ',
      loading: 'ກຳລັງໂຫຼດ...',
      noData: 'ບໍ່ມີຂໍ້ມູນ',
      revenueType: 'ປະເພດລາຍຮັບ',
      station: 'ດ່ານ/ສະຖານີ',
      allModules: 'ທຸກປະເພດ',
      allStations: 'ທຸກດ່ານ',
      toll: 'ຄ່າທາງດ່ວນ',
      bridge: 'ຄ່າຂ້າມສະພານ',
      wim: 'ຄ່າປັບນ້ຳໜັກ',
      auction: 'ປະມູນປ້າຍ',
      period: 'ໄລຍະເວລາ',
      allTransactions: 'ທຸລະກຳທັງໝົດ',
      total: 'ລວມທັງໝົດ',
      records: 'ລາຍການ',
      no: 'ລຳດັບ',
      transactionId: 'ລະຫັດທຸລະກຳ',
      dateTime: 'ວັນທີ & ເວລາ',
      type: 'ປະເພດ',
      licensePlate: 'ປ້າຍທະບຽນ',
      method: 'ວິທີຊຳລະ',
      amount: 'ຈຳນວນເງິນ (LAK)',
      status: 'ສະຖານະ',
      description: 'ລາຍລະອຽດ',
      userEmail: 'ອີເມວຜູ້ໃຊ້',
      gateLocation: 'ດ່ານ/ສະຖານທີ່',
      success: 'ສຳເລັດ',
      pending: 'ລໍຖ້າ',
      failed: 'ລົ້ມເຫຼວ',
      cash: 'ເງິນສົດ',
      barrier: 'ກີດຂວາງ',
      totalTxn: 'ຈຳນວນທຸລະກຳ',
      avgTopup: 'ສະເລ່ຍ',
    },
    th: {
      title: 'รายงาน',
      subtitle: 'สร้างและส่งออกรายงานต่างๆจากระบบเก็บค่าทางอัตโนมัติ',
      reportType: 'ประเภทรายงาน',
      startDate: 'วันที่เริ่มต้น',
      endDate: 'วันที่สิ้นสุด',
      generateReport: 'สร้างรายงาน',
      exportExcel: 'ส่งออก Excel',
      exportPdf: 'ส่งออก PDF',
      daily: 'รายงานประจำวัน',
      monthly: 'รายงานประจำเดือน',
      transaction: 'รายงานธุรกรรม',
      revenue: 'รายงานรายได้',
      loading: 'กำลังโหลด...',
      noData: 'ไม่มีข้อมูล',
      revenueType: 'ประเภทรายรับ',
      station: 'ด่าน/สถานี',
      allModules: 'ทุกประเภท',
      allStations: 'ทุกด่าน',
      toll: 'ค่าทางด่วน',
      bridge: 'ค่าข้ามสะพาน',
      wim: 'ค่าปรับน้ำหนัก',
      auction: 'ประมูลป้าย',
      period: 'ช่วงเวลา',
      allTransactions: 'ธุรกรรมทั้งหมด',
      total: 'รวมทั้งหมด',
      records: 'รายการ',
      no: 'ลำดับ',
      transactionId: 'รหัสธุรกรรม',
      dateTime: 'วันที่ & เวลา',
      type: 'ประเภท',
      licensePlate: 'ป้ายทะเบียน',
      method: 'วิธีชำระ',
      amount: 'จำนวนเงิน (LAK)',
      status: 'สถานะ',
      description: 'รายละเอียด',
      userEmail: 'อีเมลผู้ใช้',
      gateLocation: 'ด่าน/สถานที่',
      success: 'สำเร็จ',
      pending: 'รอดำเนินการ',
      failed: 'ล้มเหลว',
      cash: 'เงินสด',
      barrier: 'กีดขวาง',
      totalTxn: 'จำนวนธุรกรรม',
      avgTopup: 'ค่าเฉลี่ย',
    },
    en: {
      title: 'Reports',
      subtitle: 'Generate and export various reports from the automated toll collection system',
      reportType: 'Report Type',
      startDate: 'Start Date',
      endDate: 'End Date',
      generateReport: 'Generate Report',
      exportExcel: 'Export Excel',
      exportPdf: 'Export PDF',
      daily: 'Daily Report',
      monthly: 'Monthly Report',
      transaction: 'Transaction Report',
      revenue: 'Revenue Report',
      loading: 'Loading...',
      noData: 'No Data',
      revenueType: 'Revenue Type',
      station: 'Station',
      allModules: 'All Types',
      allStations: 'All Stations',
      toll: 'Toll Fee',
      bridge: 'Bridge Fee',
      wim: 'WIM Fine',
      auction: 'Plate Auction',
      period: 'Period',
      allTransactions: 'All Transactions',
      total: 'Total',
      records: 'records',
      no: 'No.',
      transactionId: 'Transaction ID',
      dateTime: 'Date & Time',
      type: 'Type',
      licensePlate: 'License Plate',
      method: 'Method',
      amount: 'Amount (LAK)',
      status: 'Status',
      description: 'Description',
      userEmail: 'User Email',
      gateLocation: 'Gate/Location',
      success: 'Success',
      pending: 'Pending',
      failed: 'Failed',
      cash: 'Cash',
      barrier: 'Barrier',
      totalTxn: 'Transactions',
      avgTopup: 'Average',
    },
  };

  const t = (key) => i18n[lang]?.[key] || i18n.en[key] || key;





  const handleGenerateReport = async (targetPage = 1) => {
    setLoading(true);
    setError(null);
    setPage(targetPage);
    setReportData(null);
    
    try {
      if (reportType === 'transaction' || reportType === 'revenue') {
        const params = {
          dateFrom,
          dateTo,
          revenueType: selectedModule,
          stationId: selectedStation,
          page: targetPage,
          limit: 50
        };
        
        const response = await apiClient.reportsGetTransactions(params);
        if (response && response.success) {
          const data = response.data || [];
          setTransactions(data);
          
          const pag = response.pagination || { total: data.length, page: 1, limit: 50, pages: 1, totalAmount: 0 };
          setTotalPages(pag.pages);
          
          setReportData({
            type: 'transaction',
            totalRecords: pag.total,
            totalAmount: pag.totalAmount || data.reduce((sum, tx) => sum + tx.amount, 0),
          });
        } else {
          throw new Error(response?.error || 'Failed to fetch reports transactions');
        }
      } else if (reportType === 'daily') {
        const response = await apiClient.reportsGenerateDaily({ date: dateFrom });
        if (response && response.success) {
          setTransactions([]);
          setTotalPages(1);
          setReportData({
            type: 'daily',
            reportDate: response.data.reportDate,
            summary: response.data.summary || [],
            totalAmount: response.data.grandTotal || 0,
            totalRecords: response.data.grandTxnCount || 0,
          });
        } else {
          throw new Error(response?.error || 'Failed to generate daily report');
        }
      } else if (reportType === 'monthly') {
        const dateParts = dateFrom.split('-');
        const year = parseInt(dateParts[0], 10) || new Date().getFullYear();
        const month = parseInt(dateParts[1], 10) || (new Date().getMonth() + 1);
        
        const response = await apiClient.reportsGenerateMonthly({ year, month });
        if (response && response.success) {
          setTransactions([]);
          setTotalPages(1);
          setReportData({
            type: 'monthly',
            year: response.data.year,
            month: response.data.month,
            summary: response.data.summary || [],
            totalAmount: response.data.grandTotal || 0,
            totalRecords: response.data.grandTxnCount || 0,
          });
        } else {
          throw new Error(response?.error || 'Failed to generate monthly report');
        }
      }
    } catch (err) {
      console.error('Error generating report:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleExportExcel = () => {
    if (reportType !== 'transaction') return;
    const params = {
      dateFrom,
      dateTo,
      revenueType: selectedModule,
      stationId: selectedStation
    };
    const url = apiClient.reportsGetExportUrl(params);
    window.open(url, '_blank');
  };

  const moduleLabels = {
    toll: { lo: 'ທາງດ່ວນ', th: 'ทางด่วน', en: 'Toll' },
    bridge: { lo: 'ສະພານ', th: 'สะพาน', en: 'Bridge' },
    wim: { lo: 'WIM', th: 'WIM', en: 'WIM' },
    auction: { lo: 'ປະມູນ', th: 'ประมูล', en: 'Auction' },
  };

  const getModuleName = (type) => {
    const key = String(type).toLowerCase();
    return moduleLabels[key]?.[lang] || type;
  };

  const handleExportPdf = () => {
    if (!reportData) return;
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;

    const printDate = new Date().toLocaleString('en-GB');
    let title = '';
    let summaryHtml = '';
    let tableHeadersHtml = '';
    let tableRowsHtml = '';

    if (reportData.type === 'transaction') {
      title = 'ລາຍງານທຸລະກຳລາຍຮັບ (Revenue Transactions Report)';
      summaryHtml = `
        <div>
          <div style="font-size: 11px; color: #666;">ທຸລະກຳທັງໝົດ (Total Transactions)</div>
          <div class="summary-val" style="color: #1890ff;">${reportData.totalRecords.toLocaleString()} รายการ</div>
        </div>
        <div>
          <div style="font-size: 11px; color: #666;">ລວມທັງໝົດ (Grand Total Amount)</div>
          <div class="summary-val" style="color: #52c41a;">${reportData.totalAmount.toLocaleString()} LAK</div>
        </div>
      `;
      tableHeadersHtml = `
        <tr>
          <th style="width: 5%;">No.</th>
          <th style="width: 25%;">Transaction ID</th>
          <th style="width: 18%;">Date & Time</th>
          <th style="width: 10%;">Type</th>
          <th style="width: 12%;">License Plate</th>
          <th style="width: 8%;">Method</th>
          <th style="width: 12%; text-align: right;">Amount (LAK)</th>
          <th style="width: 8%; text-align: center;">Status</th>
          <th style="width: 10%;">Location</th>
        </tr>
      `;
      transactions.forEach((tx) => {
        tableRowsHtml += `
          <tr style="border-bottom: 1px solid #ddd;">
            <td style="padding: 8px; font-size: 11px;">${tx.no}</td>
            <td style="padding: 8px; font-family: monospace; font-size: 10px;">${tx.id}</td>
            <td style="padding: 8px; font-size: 11px;">${tx.dateTime}</td>
            <td style="padding: 8px; font-size: 11px;">${tx.type}</td>
            <td style="padding: 8px; font-size: 11px; font-weight: 500;">${tx.plate}</td>
            <td style="padding: 8px; font-size: 11px;">${tx.method}</td>
            <td style="padding: 8px; font-size: 11px; text-align: right; font-weight: bold;">${tx.amount.toLocaleString()}</td>
            <td style="padding: 8px; font-size: 11px; text-align: center;">${tx.status}</td>
            <td style="padding: 8px; font-size: 11px; font-family: monospace; color: #555;">${tx.gateLocation}</td>
          </tr>
        `;
      });
    } else if (reportData.type === 'daily') {
      title = 'ລາຍງານລາຍຮັບປະຈຳວັນ (Daily Revenue Summary Report)';
      summaryHtml = `
        <div>
          <div style="font-size: 11px; color: #666;">ວັນທີລາຍງານ (Report Date)</div>
          <div class="summary-val" style="color: #1890ff;">${reportData.reportDate}</div>
        </div>
        <div>
          <div style="font-size: 11px; color: #666;">ທຸລະກຳທັງໝົດ (Total Transactions)</div>
          <div class="summary-val" style="color: #1890ff;">${reportData.totalRecords.toLocaleString()} รายการ</div>
        </div>
        <div>
          <div style="font-size: 11px; color: #666;">ລວມທັງໝົດ (Grand Total Amount)</div>
          <div class="summary-val" style="color: #52c41a;">${reportData.totalAmount.toLocaleString()} LAK</div>
        </div>
      `;
      tableHeadersHtml = `
        <tr>
          <th style="width: 5%;">No.</th>
          <th style="width: 15%;">Revenue Type</th>
          <th style="width: 15%;">Station Code</th>
          <th style="width: 25%;">Station Name</th>
          <th style="width: 15%; text-align: right;">Amount (LAK)</th>
          <th style="width: 10%; text-align: center;">Transactions</th>
          <th style="width: 15%; text-align: right;">Average (LAK)</th>
        </tr>
      `;

      let rowIdx = 1;
      (reportData.summary || []).forEach(group => {
        (group.stations || []).forEach(station => {
          tableRowsHtml += `
            <tr style="border-bottom: 1px solid #ddd;">
              <td style="padding: 8px; font-size: 11px;">${rowIdx++}</td>
              <td style="padding: 8px; font-size: 11px; font-weight: bold;">${getModuleName(group.type)}</td>
              <td style="padding: 8px; font-size: 11px; font-family: monospace;">${station.code}</td>
              <td style="padding: 8px; font-size: 11px;">${station.name}</td>
              <td style="padding: 8px; font-size: 11px; text-align: right; font-weight: bold;">${station.amount.toLocaleString()}</td>
              <td style="padding: 8px; font-size: 11px; text-align: center;">${station.txnCount.toLocaleString()}</td>
              <td style="padding: 8px; font-size: 11px; text-align: right; color: #555;">${station.average.toLocaleString()}</td>
            </tr>
          `;
        });
      });
    } else if (reportData.type === 'monthly') {
      title = 'ລາຍງານລາຍຮັບປະຈຳເດືອນ (Monthly Revenue Summary Report)';
      summaryHtml = `
        <div>
          <div style="font-size: 11px; color: #666;">ເດືອນລາຍງານ (Report Month)</div>
          <div class="summary-val" style="color: #1890ff;">${reportData.month}/${reportData.year}</div>
        </div>
        <div>
          <div style="font-size: 11px; color: #666;">ທຸລະກຳທັງໝົດ (Total Transactions)</div>
          <div class="summary-val" style="color: #1890ff;">${reportData.totalRecords.toLocaleString()} รายการ</div>
        </div>
        <div>
          <div style="font-size: 11px; color: #666;">ລວມທັງໝົດ (Grand Total Amount)</div>
          <div class="summary-val" style="color: #52c41a;">${reportData.totalAmount.toLocaleString()} LAK</div>
        </div>
      `;
      tableHeadersHtml = `
        <tr>
          <th style="width: 10%;">No.</th>
          <th style="width: 25%;">Revenue Type</th>
          <th style="width: 15%; text-align: center;">Station Count</th>
          <th style="width: 20%; text-align: right;">Amount (LAK)</th>
          <th style="width: 15%; text-align: center;">Transactions</th>
          <th style="width: 15%; text-align: right;">Average (LAK)</th>
        </tr>
      `;

      (reportData.summary || []).forEach((row, idx) => {
        tableRowsHtml += `
          <tr style="border-bottom: 1px solid #ddd;">
            <td style="padding: 10px 8px; font-size: 11px;">${idx + 1}</td>
            <td style="padding: 10px 8px; font-size: 11px; font-weight: bold;">${getModuleName(row.type)}</td>
            <td style="padding: 10px 8px; font-size: 11px; text-align: center;">${row.stationCount}</td>
            <td style="padding: 10px 8px; font-size: 11px; text-align: right; font-weight: bold;">${row.total.toLocaleString()}</td>
            <td style="padding: 10px 8px; font-size: 11px; text-align: center;">${row.txnCount.toLocaleString()}</td>
            <td style="padding: 10px 8px; font-size: 11px; text-align: right; color: #555;">${row.average.toLocaleString()}</td>
          </tr>
        `;
      });
    }

    const htmlContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>${title}</title>
        <meta charset="utf-8">
        <style>
          body {
            font-family: 'Inter', sans-serif;
            color: #333;
            padding: 20px;
            margin: 0;
          }
          .header {
            text-align: center;
            border-bottom: 2px solid #333;
            padding-bottom: 10px;
            margin-bottom: 20px;
          }
          .title {
            font-size: 20px;
            font-weight: bold;
            margin: 0 0 5px 0;
          }
          .subtitle {
            font-size: 12px;
            color: #666;
            margin: 0;
          }
          .info-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 15px;
            margin-bottom: 20px;
            font-size: 12px;
          }
          .info-item {
            margin-bottom: 5px;
          }
          .summary-card {
            background: #f9f9f9;
            border: 1px solid #ddd;
            border-radius: 6px;
            padding: 15px;
            margin-bottom: 20px;
            display: flex;
            gap: 30px;
          }
          .summary-val {
            font-size: 15px;
            font-weight: bold;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
          }
          th {
            background: #f1f1f1;
            border-bottom: 2px solid #ddd;
            padding: 10px 8px;
            font-size: 11px;
            text-align: left;
            font-weight: 600;
          }
          @media print {
            body { padding: 0; }
            .no-print { display: none; }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <div class="title">${title}</div>
          <div class="subtitle">Road Fund Central Dashboard</div>
        </div>

        <div class="info-grid">
          <div>
            <div class="info-item"><strong>ປະເພດລາຍຮັບ (Revenue Type):</strong> ${selectedModule === 'all' ? 'ທຸກປະເພດ (All Types)' : selectedModule.toUpperCase()}</div>
            <div class="info-item"><strong>ດ່ານ/ສະຖານີ (Station):</strong> ${selectedStation === 'all' ? 'ທຸກດ່ານ (All Stations)' : selectedStation}</div>
          </div>
          <div style="text-align: right;">
            <div class="info-item"><strong>ໄລຍะเวลา (Period):</strong> ${dateFrom} to ${dateTo}</div>
            <div class="info-item"><strong>ວັນທີສ້າງລາຍງານ (Generated Date):</strong> ${printDate}</div>
          </div>
        </div>

        <div class="summary-card">
          ${summaryHtml}
        </div>

        <table>
          <thead>
            ${tableHeadersHtml}
          </thead>
          <tbody>
            ${tableRowsHtml}
          </tbody>
        </table>

        <script>
          window.onload = function() {
            setTimeout(function() {
              window.print();
            }, 300);
          };
        </script>
      </body>
      </html>
    `;

    printWindow.document.open();
    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };

  const getAvailableStations = () => {
    if (selectedModule === 'all') return [];
    return stationsByModule[selectedModule] || [];
  };

  useEffect(() => {
    setSelectedStation('all');
  }, [selectedModule]);

  return (
    <div style={{ padding: '24px', background: 'var(--bg)', minHeight: '100vh' }}>
      {/* Header */}
      <div style={{ marginBottom: '24px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
          <span style={{ fontSize: '24px' }}>📊</span>
          <h1 style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: 'var(--text)' }}>{t('title')}</h1>
        </div>
        <p style={{ margin: 0, color: 'var(--text2)', fontSize: '14px' }}>{t('subtitle')}</p>
      </div>

      {/* Filter Card */}
      <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: '8px', padding: '20px', marginBottom: '20px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '16px' }}>
          {/* Report Type */}
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px', fontWeight: '500', color: 'var(--text2)' }}>
              {t('reportType')}
            </label>
            <select 
              value={reportType}
              onChange={(e) => setReportType(e.target.value)}
              style={{ 
                width: '100%', 
                padding: '8px 12px', 
                border: '1px solid var(--border)', 
                borderRadius: '6px', 
                background: 'var(--bg)', 
                color: 'var(--text)',
                fontSize: '13px',
              }}
            >
              <option value="transaction">📊 {t('transaction')}</option>
              <option value="daily">{t('daily')}</option>
              <option value="monthly">{t('monthly')}</option>
              <option value="revenue">{t('revenue')}</option>
            </select>
          </div>

          {/* Revenue Type Filter */}
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px', fontWeight: '500', color: 'var(--text2)' }}>
              {t('revenueType')}
            </label>
            <select 
              value={selectedModule}
              onChange={(e) => setSelectedModule(e.target.value)}
              style={{ 
                width: '100%', 
                padding: '8px 12px', 
                border: '1px solid var(--border)', 
                borderRadius: '6px', 
                background: 'var(--bg)', 
                color: 'var(--text)',
                fontSize: '13px',
              }}
            >
              <option value="all">{t('allModules')}</option>
              <option value="toll">🚗 {t('toll')}</option>
              <option value="bridge">🌉 {t('bridge')}</option>
              <option value="wim">⚖️ {t('wim')}</option>
              <option value="auction">🏷️ {t('auction')}</option>
            </select>
          </div>

          {/* Station Filter */}
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px', fontWeight: '500', color: 'var(--text2)' }}>
              {t('station')}
            </label>
            <select 
              value={selectedStation}
              onChange={(e) => setSelectedStation(e.target.value)}
              disabled={selectedModule === 'all'}
              style={{ 
                width: '100%', 
                padding: '8px 12px', 
                border: '1px solid var(--border)', 
                borderRadius: '6px', 
                background: selectedModule === 'all' ? 'var(--bg3)' : 'var(--bg)', 
                color: 'var(--text)',
                fontSize: '13px',
                cursor: selectedModule === 'all' ? 'not-allowed' : 'pointer',
              }}
            >
              <option value="all">{t('allStations')}</option>
              {getAvailableStations().map(station => (
                <option key={station.id} value={station.id}>
                  {station.name[lang] || station.name.en}
                </option>
              ))}
            </select>
          </div>

          {/* Start Date */}
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px', fontWeight: '500', color: 'var(--text2)' }}>
              {t('startDate')}
            </label>
            <input 
              type="date"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
              style={{ 
                width: '100%', 
                padding: '8px 12px', 
                border: '1px solid var(--border)', 
                borderRadius: '6px', 
                background: 'var(--bg)', 
                color: 'var(--text)',
                fontSize: '13px',
              }}
            />
          </div>

          {/* End Date */}
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px', fontWeight: '500', color: 'var(--text2)' }}>
              {t('endDate')}
            </label>
            <input 
              type="date"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
              style={{ 
                width: '100%', 
                padding: '8px 12px', 
                border: '1px solid var(--border)', 
                borderRadius: '6px', 
                background: 'var(--bg)', 
                color: 'var(--text)',
                fontSize: '13px',
              }}
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          <button
            onClick={() => handleGenerateReport(1)}
            disabled={loading}
            style={{
              padding: '10px 24px',
              background: '#1890ff',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: loading ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              opacity: loading ? 0.6 : 1,
            }}
          >
            📊 {loading ? t('loading') : t('generateReport')}
          </button>
          <button
            onClick={handleExportExcel}
            disabled={!reportData || reportType !== 'transaction'}
            style={{
              padding: '10px 20px',
              background: '#52c41a',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: (!reportData || reportType !== 'transaction') ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              opacity: (!reportData || reportType !== 'transaction') ? 0.4 : 1,
            }}
          >
            📗 {t('exportExcel')}
          </button>
          <button
            onClick={handleExportPdf}
            disabled={!reportData}
            style={{
              padding: '10px 20px',
              background: '#f5222d',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: !reportData ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              opacity: !reportData ? 0.4 : 1,
            }}
          >
            📕 {t('exportPdf')}
          </button>
        </div>
      </div>

      {/* Report Results */}
      {reportData && (
        <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: '8px', padding: '20px' }}>
          {/* Report Header */}
          <div style={{ marginBottom: '20px', paddingBottom: '16px', borderBottom: '1px solid var(--border)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
              <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '600', color: 'var(--text)', display: 'flex', alignItems: 'center', gap: '8px' }}>
                📊 {reportType === 'daily' ? t('daily') : reportType === 'monthly' ? t('monthly') : t('transaction')}
              </h2>
              <span style={{ fontSize: '13px', color: 'var(--text3)' }}>
                {t('period')}: {dateFrom} {t('to')} {dateTo}
              </span>
            </div>
            <div style={{ display: 'flex', gap: '16px', fontSize: '14px' }}>
              <span style={{ color: 'var(--text2)' }}>
                {reportType === 'transaction' ? t('allTransactions') : t('totalTxn')}: <strong style={{ color: '#1890ff' }}>{reportData.totalRecords.toLocaleString()}</strong> {t('records')}
              </span>
              <span style={{ color: 'var(--text3)' }}>|</span>
              <span style={{ color: 'var(--text2)' }}>
                {t('total')}: <strong style={{ color: '#52c41a' }}>{reportData.totalAmount.toLocaleString()}</strong> LAK
              </span>
            </div>
          </div>

          {/* Transaction Table */}
          {reportData.type === 'transaction' && (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                  <tr style={{ background: 'var(--bg3)', borderBottom: '2px solid var(--border)' }}>
                    <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: '600', color: 'var(--text2)' }}>{t('no')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: '600', color: 'var(--text2)' }}>{t('transactionId')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: '600', color: 'var(--text2)' }}>{t('dateTime')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: '600', color: 'var(--text2)' }}>{t('type')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: '600', color: 'var(--text2)' }}>{t('licensePlate')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: '600', color: 'var(--text2)' }}>{t('method')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'right', fontWeight: '600', color: 'var(--text2)' }}>{t('amount')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: '600', color: 'var(--text2)' }}>{t('status')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: '600', color: 'var(--text2)' }}>{t('description')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: '600', color: 'var(--text2)' }}>{t('userEmail')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: '600', color: 'var(--text2)' }}>{t('gateLocation')}</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.slice(0, 50).map((tx, index) => (
                    <tr key={index} style={{ borderBottom: '1px solid var(--border)' }}>
                      <td style={{ padding: '10px 8px', color: 'var(--text)' }}>{tx.no}</td>
                      <td style={{ padding: '10px 8px', color: 'var(--text3)', fontFamily: 'monospace', fontSize: '11px' }}>{tx.id}</td>
                      <td style={{ padding: '10px 8px', color: 'var(--text)' }}>{tx.dateTime}</td>
                      <td style={{ padding: '10px 8px' }}>
                        <span style={{ 
                          padding: '4px 8px', 
                          borderRadius: '4px', 
                          background: 'rgba(250, 140, 22, 0.15)', 
                          color: '#fa8c16',
                          fontSize: '11px',
                          fontWeight: '500',
                        }}>
                          🚧 {tx.type}
                        </span>
                      </td>
                      <td style={{ padding: '10px 8px', color: 'var(--text)', fontWeight: '500' }}>{tx.plate}</td>
                      <td style={{ padding: '10px 8px' }}>
                        <span style={{ 
                          padding: '4px 8px', 
                          borderRadius: '4px', 
                          background: 'rgba(82, 196, 26, 0.15)', 
                          color: '#52c41a',
                          fontSize: '11px',
                          fontWeight: '500',
                        }}>
                          💵 {tx.method}
                        </span>
                      </td>
                      <td style={{ padding: '10px 8px', textAlign: 'right', color: 'var(--text)', fontWeight: '600' }}>
                        {tx.amount.toLocaleString()}
                      </td>
                      <td style={{ padding: '10px 8px', textAlign: 'center' }}>
                        <span style={{ 
                          padding: '4px 10px', 
                          borderRadius: '12px', 
                          background: tx.status === 'Success' ? 'rgba(82, 196, 26, 0.15)' : 'rgba(250, 173, 20, 0.15)', 
                          color: tx.status === 'Success' ? '#52c41a' : '#faad14',
                          fontSize: '11px',
                          fontWeight: '600',
                        }}>
                          {tx.status === 'Success' ? '✓' : '⏳'} {tx.status}
                        </span>
                      </td>
                      <td style={{ padding: '10px 8px', color: 'var(--text3)' }}>{tx.description}</td>
                      <td style={{ padding: '10px 8px', color: 'var(--text2)', fontSize: '12px' }}>{tx.userEmail}</td>
                      <td style={{ padding: '10px 8px', color: 'var(--text)', fontWeight: '500' }}>{tx.gateLocation}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {reportData.type === 'daily' && (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                  <tr style={{ background: 'var(--bg3)', borderBottom: '2px solid var(--border)' }}>
                    <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: '600', color: 'var(--text2)' }}>{t('no')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: '600', color: 'var(--text2)' }}>{t('revenueType')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: '600', color: 'var(--text2)' }}>{t('gateLocation')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: '600', color: 'var(--text2)' }}>{t('station')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'right', fontWeight: '600', color: 'var(--text2)' }}>{t('amount')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: '600', color: 'var(--text2)' }}>{t('totalTxn')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'right', fontWeight: '600', color: 'var(--text2)' }}>{t('avgTopup')}</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    const rows = [];
                    let rIdx = 1;
                    (reportData.summary || []).forEach(group => {
                      (group.stations || []).forEach(st => {
                        rows.push({
                          type: group.type,
                          code: st.code,
                          name: st.name,
                          amount: st.amount,
                          txn: st.txnCount,
                          avg: st.average
                        });
                      });
                    });

                    if (rows.length === 0) {
                      return (
                        <tr>
                          <td colSpan="7" style={{ padding: '20px', textAlign: 'center', color: 'var(--text3)' }}>
                            {t('noData')}
                          </td>
                        </tr>
                      );
                    }

                    return rows.map((r, index) => (
                      <tr key={index} style={{ borderBottom: '1px solid var(--border)' }}>
                        <td style={{ padding: '10px 8px', color: 'var(--text)' }}>{index + 1}</td>
                        <td style={{ padding: '10px 8px' }}>
                          <span style={{ 
                            padding: '4px 8px', 
                            borderRadius: '4px', 
                            background: r.type === 'TOLL' ? 'rgba(250, 140, 22, 0.15)' : r.type === 'BRIDGE' ? 'rgba(24, 144, 255, 0.15)' : r.type === 'WIM' ? 'rgba(245, 34, 45, 0.15)' : 'rgba(82, 196, 26, 0.15)',
                            color: r.type === 'TOLL' ? '#fa8c16' : r.type === 'BRIDGE' ? '#1890ff' : r.type === 'WIM' ? '#f5222d' : '#52c41a',
                            fontSize: '11px',
                            fontWeight: '600',
                          }}>
                            {getModuleName(r.type)}
                          </span>
                        </td>
                        <td style={{ padding: '10px 8px', color: 'var(--text3)', fontFamily: 'monospace' }}>{r.code}</td>
                        <td style={{ padding: '10px 8px', color: 'var(--text)', fontWeight: '500' }}>{r.name}</td>
                        <td style={{ padding: '10px 8px', textAlign: 'right', color: 'var(--text)', fontWeight: '600' }}>
                          {r.amount.toLocaleString()}
                        </td>
                        <td style={{ padding: '10px 8px', textAlign: 'center', color: 'var(--text2)' }}>
                          {r.txn.toLocaleString()}
                        </td>
                        <td style={{ padding: '10px 8px', textAlign: 'right', color: 'var(--text3)' }}>
                          {r.avg.toLocaleString()}
                        </td>
                      </tr>
                    ));
                  })()}
                </tbody>
              </table>
            </div>
          )}

          {reportData.type === 'monthly' && (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                  <tr style={{ background: 'var(--bg3)', borderBottom: '2px solid var(--border)' }}>
                    <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: '600', color: 'var(--text2)' }}>{t('no')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: '600', color: 'var(--text2)' }}>{t('revenueType')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: '600', color: 'var(--text2)' }}>{t('station')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'right', fontWeight: '600', color: 'var(--text2)' }}>{t('amount')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: '600', color: 'var(--text2)' }}>{t('totalTxn')}</th>
                    <th style={{ padding: '12px 8px', textAlign: 'right', fontWeight: '600', color: 'var(--text2)' }}>{t('avgTopup')}</th>
                  </tr>
                </thead>
                <tbody>
                  {(reportData.summary || []).length === 0 ? (
                    <tr>
                      <td colSpan="6" style={{ padding: '20px', textAlign: 'center', color: 'var(--text3)' }}>
                        {t('noData')}
                      </td>
                    </tr>
                  ) : (
                    (reportData.summary || []).map((r, index) => (
                      <tr key={index} style={{ borderBottom: '1px solid var(--border)' }}>
                        <td style={{ padding: '10px 8px', color: 'var(--text)' }}>{index + 1}</td>
                        <td style={{ padding: '10px 8px' }}>
                          <span style={{ 
                            padding: '4px 8px', 
                            borderRadius: '4px', 
                            background: r.type === 'TOLL' ? 'rgba(250, 140, 22, 0.15)' : r.type === 'BRIDGE' ? 'rgba(24, 144, 255, 0.15)' : r.type === 'WIM' ? 'rgba(245, 34, 45, 0.15)' : 'rgba(82, 196, 26, 0.15)',
                            color: r.type === 'TOLL' ? '#fa8c16' : r.type === 'BRIDGE' ? '#1890ff' : r.type === 'WIM' ? '#f5222d' : '#52c41a',
                            fontSize: '11px',
                            fontWeight: '600',
                          }}>
                            {getModuleName(r.type)}
                          </span>
                        </td>
                        <td style={{ padding: '10px 8px', textAlign: 'center', color: 'var(--text)', fontWeight: '500' }}>
                          {r.stationCount}
                        </td>
                        <td style={{ padding: '10px 8px', textAlign: 'right', color: 'var(--text)', fontWeight: '600' }}>
                          {r.total.toLocaleString()}
                        </td>
                        <td style={{ padding: '10px 8px', textAlign: 'center', color: 'var(--text2)' }}>
                          {r.txnCount.toLocaleString()}
                        </td>
                        <td style={{ padding: '10px 8px', textAlign: 'right', color: 'var(--text3)' }}>
                          {r.average.toLocaleString()}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}

          {/* Pagination Controls */}
          {totalPages > 1 && (
            <div style={{ 
              display: 'flex', 
              justifyContent: 'flex-end', 
              alignItems: 'center', 
              gap: '6px', 
              marginTop: '20px' 
            }}>
              {/* Prev button */}
              <button
                onClick={() => page > 1 && handleGenerateReport(page - 1)}
                disabled={page === 1}
                style={{
                  padding: '6px 12px',
                  background: 'var(--bg2)',
                  border: '1px solid var(--border)',
                  borderRadius: '4px',
                  color: page === 1 ? 'var(--text3)' : 'var(--text)',
                  cursor: page === 1 ? 'not-allowed' : 'pointer',
                  fontSize: '12px',
                  opacity: page === 1 ? 0.5 : 1,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  fontFamily: 'inherit',
                  transition: 'all 0.2s',
                }}
              >
                ← Prev
              </button>

              {/* Page Numbers */}
              {(() => {
                const pages = [];
                // Window of 5 pages
                const startPage = Math.max(1, page - 2);
                const endPage = Math.min(totalPages, startPage + 4);
                const adjustedStart = Math.max(1, endPage - 4);
                
                for (let p = adjustedStart; p <= endPage; p++) {
                  const isActive = p === page;
                  pages.push(
                    <button
                      key={p}
                      onClick={() => handleGenerateReport(p)}
                      style={{
                        minWidth: '32px',
                        height: '32px',
                        padding: '0 6px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: isActive ? '#fa8c16' : 'var(--bg2)',
                        border: '1px solid ' + (isActive ? '#fa8c16' : 'var(--border)'),
                        borderRadius: '4px',
                        color: isActive ? 'white' : 'var(--text)',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: isActive ? '600' : 'normal',
                        fontFamily: 'inherit',
                        transition: 'all 0.2s',
                      }}
                    >
                      {p}
                    </button>
                  );
                }
                return pages;
              })()}

              {/* Next button */}
              <button
                onClick={() => page < totalPages && handleGenerateReport(page + 1)}
                disabled={page === totalPages}
                style={{
                  padding: '6px 12px',
                  background: 'var(--bg2)',
                  border: '1px solid var(--border)',
                  borderRadius: '4px',
                  color: page === totalPages ? 'var(--text3)' : 'var(--text)',
                  cursor: page === totalPages ? 'not-allowed' : 'pointer',
                  fontSize: '12px',
                  opacity: page === totalPages ? 0.5 : 1,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  fontFamily: 'inherit',
                  transition: 'all 0.2s',
                }}
              >
                Next →
              </button>
            </div>
          )}
        </div>
      )}

      {error && (
        <div style={{ marginTop: '20px', padding: '16px', background: 'rgba(245, 34, 45, 0.1)', border: '1px solid #f5222d', borderRadius: '8px', color: '#f5222d' }}>
          Error: {error}
        </div>
      )}
    </div>
  );
};

export default Reports;
